import React from 'react';

export const UnsubscribeIcon = () => (
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.1276 50.3003L57.8597 76.8091L59.0946 77.7253L60.3292 78.6412L61.6606 77.4938C62.3325 76.9148 63.1658 76.6253 63.999 76.6253C64.8322 76.6253 65.6653 76.9148 66.3373 77.4938L67.6687 78.6412L68.9034 77.7251L70.1382 76.8091L105.807 50.3473L106.005 50.2001C106.025 50.2206 106.035 50.2488 106.052 50.2714L106.212 50.1231L68.5933 17.706C65.9535 15.4312 62.0465 15.4312 59.4067 17.706L21.7884 50.1231L21.9379 50.2624C21.9546 50.2403 21.9645 50.2135 21.984 50.1937L22.1276 50.3003Z"
      fill="#392BA7"
    />
    <path
      d="M21.7949 50.1937V50.784C21.8107 50.6125 21.8772 50.4555 21.9914 50.3396L21.7949 50.1937Z"
      fill="#6E56E6"
    />
    <path
      d="M106.013 50.346C106.139 50.4764 106.218 50.6525 106.218 50.8481V50.1937L106.013 50.346Z"
      fill="#6E56E6"
    />
    <path
      d="M42.9421 26.3658H85.0579C88.9414 26.3658 92.0943 29.5187 92.0943 33.4022V72.918C92.0943 76.058 89.5451 78.6072 86.4051 78.6072H41.5949C38.455 78.6072 35.9057 76.058 35.9057 72.918V33.4022C35.9057 29.5187 39.0586 26.3658 42.9421 26.3658Z"
      fill="#F8B1DC"
    />
    <path d="M85.1191 36.209H60.3779V39.209H85.1191V36.209Z" fill="#F470BD" />
    <path
      d="M85.1191 44.9302H60.3779V47.9302H85.1191V44.9302Z"
      fill="#F470BD"
    />
    <path
      d="M85.1191 53.6514H43.3428V56.6514H85.1191V53.6514Z"
      fill="#F470BD"
    />
    <path
      d="M82.5781 62.3726H47.2959V65.3726H82.5781V62.3726Z"
      fill="#F470BD"
    />
    <path d="M55.242 36.1765H43.3882V48.3223H55.242V36.1765Z" fill="#F470BD" />
    <path
      d="M57.8597 76.8091L22.1276 50.3003L21.9839 50.1937C21.9645 50.2135 21.9546 50.2404 21.9379 50.2624C21.8566 50.3694 21.8005 50.4958 21.7873 50.6381V104.11C21.8229 105.23 22.09 106.289 22.5391 107.246L57.8597 76.8091Z"
      fill="#6E56E6"
    />
    <path
      d="M106.005 50.2001L105.807 50.3473L70.1383 76.8091L105.45 107.238C105.933 106.21 106.211 105.066 106.211 103.854V50.7023C106.211 50.5374 106.146 50.3929 106.052 50.2714C106.035 50.2488 106.025 50.2206 106.005 50.2001Z"
      fill="#6E56E6"
    />
    <path
      d="M67.6687 78.6412L66.3373 77.4938C65.6653 76.9149 64.8321 76.6254 63.999 76.6254C63.1658 76.6254 62.3325 76.9149 61.6606 77.4938L60.3292 78.6412L24.3068 109.683C25.7378 111.026 27.6573 111.854 29.7744 111.854H98.2106C100.331 111.854 102.253 111.023 103.684 109.677L67.6687 78.6412Z"
      fill="#6E56E6"
    />
    <path
      d="M60.3292 78.6412L59.0946 77.7253L57.8597 76.8091L22.5391 107.246C22.7565 107.709 23.016 108.148 23.3146 108.558C23.6102 108.963 23.9416 109.34 24.3068 109.683L60.3292 78.6412Z"
      fill="#503DC9"
    />
    <path
      d="M70.1385 76.8091L68.9037 77.7252L67.6689 78.6412L103.685 109.677C104.049 109.334 104.379 108.955 104.675 108.55C104.974 108.141 105.232 107.701 105.45 107.238L70.1385 76.8091Z"
      fill="#503DC9"
    />
    <path
      d="M104.942 127.884C117.613 127.884 127.884 117.613 127.884 104.942C127.884 92.2715 117.613 82 104.942 82C92.2715 82 82 92.2715 82 104.942C82 117.613 92.2715 127.884 104.942 127.884Z"
      fill="#EE399E"
    />
    <path
      d="M105 109.146L100.216 113.93C99.9951 114.15 99.703 114.387 99.3167 114.559C98.9226 114.734 98.5243 114.8 98.1428 114.8C97.7613 114.8 97.363 114.734 96.9689 114.559C96.5826 114.387 96.2906 114.15 96.07 113.93C94.9099 112.77 94.9099 110.944 96.07 109.784L100.854 105L96.07 100.216C94.9099 99.0556 94.9099 97.2302 96.07 96.0701C97.2301 94.91 99.0555 94.91 100.216 96.0701L105 100.854L109.784 96.0701C110.944 94.91 112.77 94.91 113.93 96.0701C115.09 97.2302 115.09 99.0556 113.93 100.216L109.146 105L113.93 109.784C115.09 110.944 115.09 112.77 113.93 113.93C113.342 114.518 112.531 114.8 111.857 114.8C111.183 114.8 110.373 114.518 109.784 113.93L105 109.146Z"
      fill="white"
    />
  </svg>
);
